module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA8gAAAPIBlLUtiQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAB9SURBVFiF7dexDcIwEAXQd4gZ2IIZ0jINdcahZwGaFGyQLRjDNKGNIxQpzT/py1d8yc+lYUI7KFMtywtv63PHB89Ob+sMuFkAY2vNWjDj0ettDUa0006v+XsCCCCAAAIIIIAAAggggAACOC/nUFW97gXXqhp3unv4LYd+z7+F6ZdCFgnJ4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar.png
// module id = 238
// module chunks = 0